/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Speaker_Id_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Speaker ID" |
*
* @param {Automatic_Speaker_Id_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_speaker_id_title = /** @type {((inputs?: Automatic_Speaker_Id_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Speaker_Id_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identification auto des intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Sprecheridentifizierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Identificazione automatica dell'altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая идентификация говорящего")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación automática del orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动说话人识别")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動スピーカーID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित स्पीकर आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Identificação automática de locutor")
	return /** @type {LocalizedString} */ ("Automatic Speaker ID")
});